/**
 * @generated SignedSource<<436b8af4fec8a4f097fac13e0ee9ca0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AppVisibility = "EVERYONE" | "ONLY_OWNER" | "OWNER_OR_ADMIN" | "%future added value";
export type AppVisibilityFormUpdateVisibilityMutation$variables = {
  appId: string;
  appVisibility: AppVisibility;
};
export type AppVisibilityFormUpdateVisibilityMutation$data = {
  readonly updateApp: {
    readonly id: string;
    readonly visibility: AppVisibility;
  };
};
export type AppVisibilityFormUpdateVisibilityMutation = {
  response: AppVisibilityFormUpdateVisibilityMutation$data;
  variables: AppVisibilityFormUpdateVisibilityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appVisibility"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appVisibility",
        "variableName": "appVisibility"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "appId"
      }
    ],
    "concreteType": "App",
    "kind": "LinkedField",
    "name": "updateApp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "visibility",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppVisibilityFormUpdateVisibilityMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppVisibilityFormUpdateVisibilityMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7486be1a46bc2e8c118c4c3fe89630b3",
    "id": null,
    "metadata": {},
    "name": "AppVisibilityFormUpdateVisibilityMutation",
    "operationKind": "mutation",
    "text": "mutation AppVisibilityFormUpdateVisibilityMutation(\n  $appId: ID!\n  $appVisibility: AppVisibility!\n) {\n  updateApp(id: $appId, appVisibility: $appVisibility) {\n    id\n    visibility\n  }\n}\n"
  }
};
})();

(node as any).hash = "d34ed8f8c0110305ac93c4f4a1c22d67";

export default node;
